import React, { FC, ChangeEvent } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
    updateFilter,
    durationSelector,
    transportTypeSelector
} from '../../../reducers/filters';
import { MultiColumnDropdownWithLabelTravelTime } from '../../../search/common/Dropdown.styles';

import { getTranslator } from '../../i18n/getTranslator';
import searchTranslations from 'public/locales/en/search.json';
import { DropdownContainer } from '../../../search/common/DropdownContainer';
import { DropdownWithLabel } from '@blueprint/dropdown';

const t = getTranslator(searchTranslations);

export const SelectMaxTravelTimeAndTransportMode: FC = () => {
    const reduxDispatch = useDispatch();
    const {
        selectedValue: durationValue,
        options: durationOptions
    } = useSelector(durationSelector);

    const {
        selectedValue: transportTypeSelectedValue,
        options: transportTypeOptions
    } = useSelector(transportTypeSelector);

    const onDurationChange = (evt: ChangeEvent<HTMLSelectElement>) => {
        reduxDispatch(updateFilter('duration', evt.currentTarget.value));
    };

    const onTransportTypeChange = (evt: ChangeEvent<HTMLSelectElement>) => {
        reduxDispatch(updateFilter('transportType', evt.currentTarget.value));
    };

    const durationTitleDisplay = t(
        `filters.field.duration.options.${durationValue || durationOptions[0]}`
    );

    const travelTypeDurationType = t(
        `filters.field.transportType.options.${
            transportTypeSelectedValue || transportTypeOptions[0]
        }`
    );
    const title = `${durationTitleDisplay} • ${travelTypeDurationType}`;

    const travelTimeTitle = t('filters.travelTime');
    const travelTimeLabelText = t('filters.field.duration.legend');

    return (
        <MultiColumnDropdownWithLabelTravelTime
            title={title}
            label={travelTimeTitle}
            testId="sub_header_max-travel-and-transport-type-dropdowns"
            isLeft
        >
            <DropdownContainer>
                <DropdownWithLabel
                    id="duration"
                    onChange={onDurationChange}
                    value={durationValue}
                    hasBorderRadius
                    name="duration"
                    label={travelTimeLabelText}
                    aria-label="Max travel time"
                    data-testid="sub_header_select-max-travel-time-dropdown"
                >
                    {durationOptions?.map((option) => {
                        const { label, value } = option;

                        return (
                            <option
                                key={`sub-header-duration-${value}`}
                                value={value}
                            >
                                {label}
                            </option>
                        );
                    })}
                </DropdownWithLabel>
            </DropdownContainer>
            <DropdownContainer>
                <DropdownWithLabel
                    id="transportType"
                    onChange={onTransportTypeChange}
                    value={transportTypeSelectedValue}
                    name="transportType"
                    hasBorderRadius
                    label={travelTimeLabelText}
                    aria-label="Transport mode"
                    data-testid="sub_header_select-transport-type-dropdown"
                >
                    {transportTypeOptions?.map((option) => {
                        const { label, value } = option;

                        return (
                            <option
                                key={`sub-header-transportType-${value}`}
                                value={value}
                            >
                                {label}
                            </option>
                        );
                    })}
                </DropdownWithLabel>
            </DropdownContainer>
        </MultiColumnDropdownWithLabelTravelTime>
    );
};
